/* VON MÜLLER | titulares en una sola línea (01-10-2026, petición de Johanna: «los títulos y subtítulos intenta que
   vayan siempre en una sola línea, no separes en 2 o 3 líneas titulares grandes»).
   Cada titular de la lista se mide sin saltos de línea; si no cabe en su columna, se reduce su tamaño lo justo para
   que quepa. Límite: nunca por debajo del 50 % de su tamaño de diseño ni de 20 px. Si ni así cabe (un título muy
   largo en móvil), se deja como estaba: varias líneas equilibradas. Se recalcula al cargar las fuentes y al cambiar
   el ancho de la ventana. Cargado por sections/vm-cambios.liquid (grupo de cabecera). Estilos asociados: assets/vm-cambios-johanna.css.
   01-10-2026, ronda 2 (P-02): excepciones a «una línea».
     - Titulares con líneas ya marcadas en Liquid (<span class="vm-fit-line">, p. ej. «Lista Forbes Women | Las 50
       Latinas a Seguir 2026» en la prensa de Inicio, snippets/vm-phome-item.liquid): cada línea en una sola línea, todas
       al mismo tamaño.
     - Titulares de solo texto que no caben ni al límite: se parten en frases («¿No encuentras tu silla? |
       Escríbeme igualmente.») o, si es una sola frase, por los dos puntos («El plan que lo cambia todo: | hidroavión a
       Victoria»), una parte por línea, cada una en una sola línea. Solo cambia la presentación: el texto no se toca
       y se restaura antes de cada nuevo cálculo. Si alguna parte sigue sin caber, varias líneas equilibradas.
     - Los títulos-frase del recorrido de Mi historia (.vm-tl__title) y los extractos bajo el título (.vm-ed__stand)
       no están en la lista: se tratan como texto. */
(function () {
  var SEL = [
    '.vm-hero__h1', '.vm-phead__h1', '.vm-display', '.vm-h1', '.vm-cta__title', '.vm-intro__statement',
    '.vm-mstripe__h', '.vm-pillar__title', '.vm-biz__name', '.vm-phome__lead-title', '.vm-shead__title',
    '.vm-services__intro', '.vm-ed__h1-line', '.vm-ed__text > h2', '.vm-ed__text > h3',
    '.vm-col__title', /* 01-10, ronda 2: Mis negocios (/pages/negocios), «La Terraza del Campo del Moro» */
    /* 01-10, ronda 2: .vm-biz__name en lugar de .vm-biz__id. El nombre del negocio lleva su propio tamaño (≈26 px en
       escritorio, 20 px en móvil) y el h3 que lo contiene mide 32 px heredados: reducir el h3 no reducía el nombre, que
       seguía en dos líneas («La Terraza del Campo del Moro»). En móvil (20 px) queda fuera de la regla. */
    'main h1', 'main h2'
  ].join(',');
  var MIN_DESIGN = 24;   /* solo titulares grandes: tamaño de diseño de 24 px o más */
  var FLOOR = 0.5;       /* nunca menos de la mitad del tamaño de diseño */
  var ABS_MIN = 20;

  /* 01-10, ronda 2: partes de un titular de solo texto, para la última opción. Frases (. ? ! …) primero; si es una sola frase,
     los primeros dos puntos. Devuelve null si no hay por dónde partir. */
  function parts(text) {
    var t = text.replace(/\s+/g, ' ').trim();
    /* sin lookbehind: Safari anterior a 16.4 no lo entiende y el script entero fallaría */
    var s = t.replace(/([.?!…])\s+(?=[¿¡«"“(]?[A-ZÁÉÍÓÚÑÜ0-9])/g, '$1\u0000').split('\u0000');
    if (s.length > 1) return s;
    var i = t.indexOf(': ');
    if (i > 0 && i < t.length - 2) return [t.slice(0, i + 1), t.slice(i + 2)];
    return null;
  }

  /* Mide líneas ya separadas (bloques .vm-fit-line) y reduce el titular entero si alguna no cabe. true = cabe. */
  function fitLines(el, fs) {
    var lines = el.querySelectorAll('.vm-fit-line'), ratio = 1;
    for (var i = 0; i < lines.length; i++) {
      var need = lines[i].scrollWidth, avail = lines[i].clientWidth;
      if (avail > 0 && need > avail + 1) ratio = Math.min(ratio, avail / need);
    }
    if (ratio === 1) return true;
    var next = Math.floor(fs * ratio * 0.98 * 10) / 10;
    if (next < Math.max(fs * FLOOR, ABS_MIN)) return false;
    el.style.fontSize = next + 'px';
    return true;
  }

  function unsplit(el) {
    if (el.dataset.vmFitText == null) return;
    el.textContent = el.dataset.vmFitText;
    delete el.dataset.vmFitText;
  }

  function fit(el) {
    if (el.closest('.vm-label') || el.classList.contains('vm-label')) return;
    if (el.querySelector('.vm-ed__h1-line')) return; /* los titulares de artículo se ajustan línea a línea */
    unsplit(el);
    el.style.removeProperty('font-size');
    el.classList.remove('vm-fit', 'vm-fit--wrap');
    var fs = parseFloat(getComputedStyle(el).fontSize);
    if (!fs || fs < MIN_DESIGN || el.offsetParent === null) return;
    el.classList.add('vm-fit');
    /* líneas marcadas en Liquid: cada una en su línea */
    if (el.querySelector('.vm-fit-line')) {
      if (!fitLines(el, fs)) { el.classList.remove('vm-fit'); el.classList.add('vm-fit--wrap'); }
      return;
    }
    /* el ancho disponible es el menor entre el propio titular y la caja de contenido de su contenedor: en algunas
       rejillas (pilares) la pista crece con el texto sin saltos y el titular parecería caber */
    var par = el.parentElement, pcs = getComputedStyle(par);
    var pav = par.clientWidth - parseFloat(pcs.paddingLeft) - parseFloat(pcs.paddingRight);
    var avail = Math.min(el.clientWidth, pav > 0 ? pav : el.clientWidth), need = el.scrollWidth;
    if (need <= avail + 1) return;
    var next = Math.floor(fs * (avail / need) * 0.98 * 10) / 10;
    if (next >= Math.max(fs * FLOOR, ABS_MIN)) {
      el.style.fontSize = next + 'px';
      /* 01-10, ronda 2: comprobación tras reducir. Si la caja depende del tamaño de letra (un ancho en ch, una
         pista de rejilla) puede seguir sin caber: se vuelve a medir (dos veces como mucho) y, si no, varias líneas. */
      for (var k = 0; k < 2 && el.scrollWidth > el.clientWidth + 1; k++) {
        next = Math.floor(next * (el.clientWidth / el.scrollWidth) * 0.98 * 10) / 10;
        if (next < Math.max(fs * FLOOR, ABS_MIN)) break;
        el.style.fontSize = next + 'px';
      }
      if (el.scrollWidth <= el.clientWidth + 1) return;
      el.style.removeProperty('font-size');
    }
    /* 01-10, ronda 2: no cabe ni al límite. Titular de solo texto: una frase (o cada lado de los dos puntos) por línea. */
    var p = el.children.length === 0 ? parts(el.textContent) : null;
    if (p) {
      el.dataset.vmFitText = el.textContent;
      el.textContent = '';
      for (var i = 0; i < p.length; i++) {
        if (i) el.appendChild(document.createTextNode(' '));
        var s = document.createElement('span');
        s.className = 'vm-fit-line';
        s.textContent = p[i];
        el.appendChild(s);
      }
      if (fitLines(el, fs)) return;
      el.style.removeProperty('font-size');
      unsplit(el);
    }
    el.classList.remove('vm-fit');
    el.classList.add('vm-fit--wrap');
  }

  /* Titulares hermanos (mismo estilo, cada uno en su columna de la misma rejilla, p. ej. los tres pilares) se igualan
     al tamaño menor, para que no queden a tamaños distintos.
     01-10, ronda 2: los nombres de Mis negocios no comparten abuelo (cada uno va en su ficha): se agrupan por la rejilla. */
  var GROUP = '.vm-biz__grid';
  function harmonize(els) {
    var groups = new Map();
    for (var i = 0; i < els.length; i++) {
      var el = els[i], p = el.parentElement, g = el.closest(GROUP) || (p && p.parentElement);
      if (!g || !el.classList.contains('vm-fit')) continue;
      var key = el.tagName + '.' + el.className.replace(/\bvm-fit\b/, '').trim();
      var k = groups.get(g); if (!k) { k = {}; groups.set(g, k); }
      (k[key] = k[key] || []).push(el);
    }
    groups.forEach(function (k) {
      Object.keys(k).forEach(function (key) {
        var list = k[key]; if (list.length < 2) return;
        var parents = new Set(list.map(function (e) { return e.parentElement; }));
        if (parents.size < 2) return;
        var min = Math.min.apply(null, list.map(function (e) { return parseFloat(getComputedStyle(e).fontSize); }));
        list.forEach(function (e) { if (parseFloat(getComputedStyle(e).fontSize) > min) e.style.fontSize = min + 'px'; });
      });
    });
  }

  function run() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) fit(els[i]);
    harmonize(els);
  }

  var t;
  function later() { clearTimeout(t); t = setTimeout(run, 120); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  window.addEventListener('load', run);
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; later(); } });
  document.addEventListener('shopify:section:load', run);
})();
